import cn from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import template from 'lodash.template';

import useMartyContext from 'hooks/useMartyContext';
import { AriaLiveTee } from 'components/common/AriaLive';
import { makeonMouseEnterForNonTouchDevices } from 'helpers';
import ProductUtils from 'helpers/ProductUtils';

import css from 'styles/components/productdetail/addToCart.scss';

const AddToCart = ({ productStyle, selectedSizing, sizing, addToCartText, lowStockMessage, onShowSelectSizeTooltip, onHideSelectSizeTooltip, mouseEnterFactory, isGiftCard, className }, { testId }) => {
  const { marketplace: { pdp: { oosDisableButton } } } = useMartyContext();
  const { colorId, productId } = productStyle;
  let onHand = 1;
  let buttonText = addToCartText;
  let stockMessage;
  let stockInput;
  let stockId;
  let isDisabled;

  // If all dimensions are chosen, check the stock
  if (ProductUtils.isSizeSelectionComplete(sizing, selectedSizing)) {

    const stock = ProductUtils.getStockBySize(sizing.stockData, colorId, selectedSizing);

    if (stock) {
      stockInput = <input type="hidden" name="stockId" value={stock.id}/>;
      stockId = stock.id;
      onHand = parseInt(stock.onHand);
      if (onHand < 10 && lowStockMessage) {
        const compiled = template(lowStockMessage);
        stockMessage = compiled({ onHand });
      }
    } else {
      isDisabled = oosDisableButton;
      onHand = 0;
      buttonText = 'Out of Stock';
    }
  }

  const showTooltipHandler = mouseEnterFactory(onShowSelectSizeTooltip);
  return (
    <div className={cn(css.addToCartControl, { [css.giftCard]: isGiftCard }, className)}>
      {stockInput}
      <input type="hidden" name="productId" value={productId}/>
      <input type="hidden" name="colorId" value={colorId}/>
      <div className={css.btnContainer}>
        <button
          type="submit"
          className={cn(css.cartButton, { [css.mobileOos]: onHand < 1 && !oosDisableButton })}
          onMouseEnter={showTooltipHandler}
          onMouseLeave={onHideSelectSizeTooltip}
          onFocus={showTooltipHandler}
          onBlur={onHideSelectSizeTooltip}
          disabled={isDisabled}
          data-stock-id={stockId}
          data-track-action="Product-Page"
          data-track-label="PrForm"
          data-track-value="Add-To-Cart"
          data-test-id={testId('addToCart')}>
          {buttonText}
        </button>
        {Boolean(stockMessage) && <div className={css.stockMessage} data-test-id={testId('stockMessage')}><AriaLiveTee>{stockMessage}</AriaLiveTee></div>}
      </div>
    </div>
  );
};

AddToCart.contextTypes = {
  testId: PropTypes.func
};

AddToCart.defaultProps = {
  mouseEnterFactory: makeonMouseEnterForNonTouchDevices
};

AddToCart.propTypes = {
  productStyle: PropTypes.object,
  selectedSizing: PropTypes.object,
  sizing: PropTypes.object,
  addToCartText: PropTypes.string,
  onShowSelectSizeTooltip: PropTypes.func,
  onHideSelectSizeTooltip: PropTypes.func
};

export default AddToCart;
